import React from 'react';

interface IProps {
  text: string;
  link?: string;
  query?: string;
}

export const SupportedLinkDescription:React.FC<IProps> = ({ text = '', link = '', query = '' }) => (
  <>
    {text}
    {link && (
    <a
      className="color--special"
      href={`${link.startsWith('http') ? link : `https://${link}`}${query ? (link.includes('?') ? '&' : '?') + query : ''}`}
      target="_blank"
      rel="noreferrer"
    >
      {link}
    </a>
    )}
  </>
);
